<div class="modal-backdrop" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <h2>Create New Agent</h2>
      <button class="close-btn" (click)="onCancel()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form (ngSubmit)="onSubmit()" #agentForm="ngForm" class="modal-body">
      <!-- General Error -->
      <div class="error-message" *ngIf="errors['general']">
        <i class="fas fa-exclamation-circle"></i>
        {{ errors['general'] }}
      </div>

      <!-- Agent Name -->
      <div class="form-group">
        <label for="agentName" class="form-label">
          Agent Name <span class="required">*</span>
        </label>
        <input
          type="text"
          id="agentName"
          name="agentName"
          [(ngModel)]="agentData.name"
          [class.error]="hasError('name')"
          class="form-input"
          placeholder="Enter agent's full name"
          required
          maxlength="100"
          [disabled]="isSubmitting">
        <div class="field-error" *ngIf="hasError('name')">
          <i class="fas fa-exclamation-triangle"></i>
          {{ getError('name') }}
        </div>
        <div class="field-hint">
          Enter the full name of the agent (2-100 characters)
        </div>
      </div>

      <!-- Phone Number -->
      <div class="form-group">
        <label for="phoneNumber" class="form-label">
          Phone Number <span class="required">*</span>
        </label>
        <input
          type="tel"
          id="phoneNumber"
          name="phoneNumber"
          [(ngModel)]="agentData.phoneNumber"
          (input)="onPhoneNumberInput($event)"
          [class.error]="hasError('phonenumber')"
          class="form-input"
          placeholder="+91 00000 00000"
          required
          maxlength="17"
          [disabled]="isSubmitting">
        <div class="field-error" *ngIf="hasError('phonenumber')">
          <i class="fas fa-exclamation-triangle"></i>
          {{ getError('phonenumber') }}
        </div>
        <div class="field-hint">
          Enter a valid Indian mobile number (10 digits starting with 6,7,8,9)
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="onCancel()"
          [disabled]="isSubmitting">
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="isSubmitting || !agentForm.valid">
          <span *ngIf="!isSubmitting">
            <i class="fas fa-user-plus"></i>
            Create Agent
          </span>
          <span *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i>
            Creating...
          </span>
        </button>
      </div>
    </form>
  </div>
</div>
